import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-slate-950 text-slate-400 py-20 border-t border-slate-900">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
                    <div className="space-y-8 col-span-1 lg:col-span-1">
                        <h2 className="text-3xl font-black text-white flex items-center gap-3">
                            <i className="fas fa-globe-americas text-amber-500 animate-pulse"></i>
                            <span className="tracking-tighter"><span className="text-amber-500">Gypsy</span>Travels</span>
                        </h2>
                        <p className="text-sm font-medium leading-relaxed max-w-xs">
                            Curating extraordinary journeys for those who seek the exceptional. Explore the world with confidence and style.
                        </p>
                        <div className="flex items-center gap-4">
                            <span className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center hover:bg-amber-500 hover:text-slate-950 transition-all cursor-pointer shadow-xl border border-slate-800">
                                <i className="fab fa-facebook-f"></i>
                            </span>
                            <span className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center hover:bg-amber-500 hover:text-slate-950 transition-all cursor-pointer shadow-xl border border-slate-800">
                                <i className="fab fa-twitter"></i>
                            </span>
                            <span className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center hover:bg-amber-500 hover:text-slate-950 transition-all cursor-pointer shadow-xl border border-slate-800">
                                <i className="fab fa-instagram"></i>
                            </span>
                        </div>
                    </div>

                    <div className="space-y-8">
                        <h3 className="text-xs font-black text-amber-500 uppercase tracking-[0.2em] ml-1">Contact Details</h3>
                        <div className="space-y-4">
                            <p className="flex items-center gap-4 text-sm hover:text-white transition-colors">
                                <span className="w-8 h-8 rounded-lg bg-slate-900 flex items-center justify-center text-amber-500 border border-slate-800"><i className="fas fa-map-marker-alt"></i></span> 
                                Chittagong, Bangladesh
                            </p>
                            <p className="flex items-center gap-4 text-sm hover:text-white transition-colors">
                                <span className="w-8 h-8 rounded-lg bg-slate-900 flex items-center justify-center text-amber-500 border border-slate-800"><i className="fas fa-envelope"></i></span> 
                                info@gypsytravels.com
                            </p>
                            <p className="flex items-center gap-4 text-sm hover:text-white transition-colors">
                                <span className="w-8 h-8 rounded-lg bg-slate-900 flex items-center justify-center text-amber-500 border border-slate-800"><i className="fas fa-phone-alt"></i></span> 
                                +880 1755555555
                            </p>
                        </div>
                    </div>

                    <div className="space-y-8">
                        <h3 className="text-xs font-black text-amber-500 uppercase tracking-[0.2em] ml-1">Destinations</h3>
                        <ul className="grid grid-cols-1 gap-4">
                            <li><span className="text-sm font-bold hover:text-amber-500 transition-all cursor-pointer flex items-center gap-2"><i className="fas fa-chevron-right text-[10px] text-slate-700"></i> Private Villas</span></li>
                            <li><span className="text-sm font-bold hover:text-amber-500 transition-all cursor-pointer flex items-center gap-2"><i className="fas fa-chevron-right text-[10px] text-slate-700"></i> Luxury Resorts</span></li>
                            <li><span className="text-sm font-bold hover:text-amber-500 transition-all cursor-pointer flex items-center gap-2"><i className="fas fa-chevron-right text-[10px] text-slate-700"></i> Private Charters</span></li>
                            <li><span className="text-sm font-bold hover:text-amber-500 transition-all cursor-pointer flex items-center gap-2"><i className="fas fa-chevron-right text-[10px] text-slate-700"></i> Boutique Hotels</span></li>
                        </ul>
                    </div>

                    <div className="space-y-8">
                        <h3 className="text-xs font-black text-amber-500 uppercase tracking-[0.2em] ml-1">Newsletter</h3>
                        <div className="space-y-4">
                            <p className="text-xs font-medium leading-relaxed">Join our elite list of travelers and get exclusive deals.</p>
                            <div className="flex w-full">
                                <input type="email" placeholder="Email" className="bg-slate-900 border border-slate-800 rounded-l-xl px-4 py-3 text-xs focus:outline-none focus:border-amber-500 w-full transition-all font-bold" />
                                <button className="bg-amber-500 text-slate-950 px-4 py-3 rounded-r-xl transition-all hover:bg-white active:scale-95 shadow-lg shadow-amber-500/10">
                                    <i className="fas fa-paper-plane"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-10 border-t border-slate-900/50 flex flex-col md:flex-row items-center justify-between gap-6 text-[10px] font-black uppercase tracking-[0.2em] text-slate-600">
                    <p>&copy; {new Date().getFullYear()} GypsyTravels &bull; Crafting Adventures</p>
                    <div className="flex gap-8">
                        <Link to="/" className="hover:text-amber-500 transition-all">Privacy</Link>
                        <Link to="/" className="hover:text-amber-500 transition-all">Support</Link>
                        <Link to="/" className="hover:text-amber-500 transition-all">Terms</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;